export default __webpack_public_path__ + "static/media/new-add-plus-green-icon.6ba0a8aa.svg";